
/// <reference path="../../../../../../../../scripts/typings/knockout/knockout.d.ts" />
/// <reference path="../../../../../../../../scripts/typings/jquery/jquery.d.ts" />
// CryptoJS referenced in Master, could not find a Typescript version

module Elma.Bindings {
    export interface IaddToGtmDatalayerParams {
        dataAttributeName: string
    }

    export class AddToGtmDatalayer {
        public init(element: any, valueAccessor: () => IaddToGtmDatalayerParams, allBindingsAccessor?:          KnockoutAllBindingsAccessor, viewModel?: any, bindingContext?: KnockoutBindingContext) 
        {
            var params = valueAccessor();
            var json = $(element).data(params.dataAttributeName);
            
            var windowAny = (window as any);
            windowAny.dataLayer.push(json);
            windowAny.dataLayer.push({
                event: 'SendTransactionToGoogleAnalyctics'
            });
            
            var orderDataDiv = $(".order-info");
            var userDataAttr = orderDataDiv.attr("data-user-info");
            var orderCurrency = orderDataDiv.attr("data-order-currency");
            var orderPayment = orderDataDiv.attr("data-order-payment");
            var orderShipping = orderDataDiv.attr("data-order-shipping");
            var userData = JSON.parse(userDataAttr);
            
            var userId = userData[0];
            var userIdHashed = CryptoJS.SHA256(userId).toString();
            
            var userCustomerType;
            if (userData[1] == "Privat") {
                userCustomerType = "private";
            } else if (userData[1] == "Virksomhed" || userData[1] == "Erhverv" || userData[1] == "Offentlig") {
                userCustomerType = "B2B";
            }
            
            var userLoginStatus;
            if (userData[2] == "False") {
                userLoginStatus = "not logged in";
            } else {
                userLoginStatus = "logged in";
            }

            var userPostcode = userData[3]
            var userPostcodeHashed = CryptoJS.SHA256(userPostcode).toString();
            
            var userCity = userData[4]
            var userCityHashed = CryptoJS.SHA256(userCity).toString();

            var userStreet = userData[5]
            var userStreetHashed = CryptoJS.SHA256(userStreet).toString();

            var userCountry = userData[6]
            var userCountryHashed = CryptoJS.SHA256(userCountry).toString();
            
            var userName = userData[7];
            userName = userName.split(" ");
            var userFirstName = userName[0];
            var userFirstNameHashed = CryptoJS.SHA256(userFirstName).toString();
            var userLastName = userName[userName.length-1];
            var userLastNameHashed = CryptoJS.SHA256(userLastName).toString();

            var userPhone = userData[8]
            var userPhoneHashed = CryptoJS.SHA256(userPhone).toString();
            
            var productDataDivs = $(".summary-orderline");
            var items = [];

            productDataDivs.each(function() {
                var productDataAttr = $(this).attr("data-product-info");
                var productData = JSON.parse(productDataAttr);
                var name = productData[0];
                var id = productData[1];
                var country = productData[2];
                var beforePrice = productData[3];
                var beforePriceVat = (beforePrice/100)*25;
                var beforePriceWithVat = beforePrice + beforePriceVat;
                var price = productData[4];
                var currency = productData[5];
                var brand = productData[6];
                var primaryGroup = productData[7];
                var quantity = productData[8];
                
                price = price.replace(",", ".");
                var priceParsed = parseFloat(price);
                var quantityParsed = parseInt(quantity);

                // Push product items to GA4 Datalayer
                items.push({
                    item_name: name,
                    item_id: id,
                    affiliation: country,
                    discount: beforePriceWithVat,
                    price: priceParsed,
                    item_brand: brand,
                    item_category: primaryGroup,
                    quantity: quantityParsed,
                    currency: currency
                })
            });

            windowAny.dataLayer.push({
                event: 'purchase',
                userData: {
                    userId: userIdHashed,
                    customerType: userCustomerType,
                    loginStatus: userLoginStatus,
                    postCode: userPostcodeHashed,
                    city: userCityHashed,
                    street: userStreetHashed,
                    country: userCountryHashed,
                    firstname: userFirstNameHashed,
                    lastname: userLastNameHashed,
                    phoneNumber: userPhoneHashed
                },
                ecommerce: {
                    transaction_id: json.transactionId,
                    affiliation: json.transactionAffiliation,
                    value: json.transactionTotal,
                    tax: json.transactionTax,
                    shipping: json.transactionShipping,
                    currency: orderCurrency,
                    payment_type: orderPayment,
                    shipping_tier: orderShipping,
                    items: items
                }
            });
            
            console.log("Datalayer", windowAny.dataLayer);
            
        }
    }

    ko.bindingHandlers['addToGtmDatalayer'] = new AddToGtmDatalayer();
}